/**
 * Contact roles — single source of truth for all role keys and labels.
 * Maps to backend canonical role keys (contactRoles.js).
 */
export const CONTACT_ROLES = [
	{ key: 'ceo', label: 'Geschäftsführung', description: 'CEO, Geschäftsführer, Inhaber, Vorstand' },
	{ key: 'prokura', label: 'Prokura', description: 'Handlungsvollmacht' },
	{ key: 'it', label: 'IT-Leitung' },
	{ key: 'marketing', label: 'Marketing' },
	{ key: 'sales', label: 'Vertrieb' },
	{ key: 'buyer', label: 'Einkauf' },
	{ key: 'hr', label: 'Personalwesen' },
	{ key: 'operations', label: 'Betrieb' },
	{ key: 'engineering', label: 'Technik' },
	{ key: 'finance', label: 'Finanzen' },
	{ key: 'shareholder', label: 'Gesellschafter', enrichable: false },
	{ key: 'liquidator', label: 'Liquidator', enrichable: false },
	{ key: 'company', label: 'Firmenkontakt', enrichable: false },
	{ key: 'unknown', label: 'Sonstige', enrichable: false },
];

export const getGermanLabel = (key) => {
	const role = CONTACT_ROLES.find((r) => r.key === key);
	return role ? role.label : key;
};

// Roles the contact enrichment can search for.
export const ENRICHABLE_ROLE_OPTIONS = CONTACT_ROLES.filter((r) => r.enrichable !== false);

// Roles selectable in the recipient role-priority picker: every enrichable role plus the
// 'company' pseudo-role (the company itself as recipient / generic Firmenkontakt rows).
export const PRIORITY_ROLE_OPTIONS = CONTACT_ROLES.filter((r) => r.enrichable !== false || r.key === 'company');

// All roles enabled, Geschäftsführung first, Firma last — the closest analog of the previous
// hardcoded "bester Kontakt" behavior.
export const DEFAULT_ROLE_PRIORITY = [
	'ceo',
	'prokura',
	'sales',
	'marketing',
	'buyer',
	'hr',
	'it',
	'engineering',
	'finance',
	'operations',
	'company',
];

/**
 * Drops keys that are no longer valid picker options (e.g. stale persisted localStorage state
 * after a role rename) so they never reach the API.
 *
 * @param {string[]|null|undefined} keys
 * @returns {string[]} the sanitized list, or the default priority when nothing valid remains
 */
export const sanitizeRolePriority = (keys) => {
	const validKeys = new Set(PRIORITY_ROLE_OPTIONS.map((r) => r.key));
	const sanitized = (keys ?? []).filter((key) => validKeys.has(key));
	return sanitized.length > 0 ? sanitized : DEFAULT_ROLE_PRIORITY;
};
